import { cn } from '../../utils.js';
import { HTMLAttributes } from 'react';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  delay?: number;
}

export const SKELETON_DELAY = 170; // ms

function Skeleton({ className, delay, style, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-gray-500', className)}
      style={{
        ...(delay
          ? {
              animationDelay: `${SKELETON_DELAY * delay}ms`,
              animationFillMode: 'backwards',
            }
          : {}),
        ...style,
      }}
      {...props}
    />
  );
}

export { Skeleton };
